import { render, staticRenderFns } from "./Attribute.global.vue?vue&type=template&id=af619e0c&scoped=true&lang=pug&"
import script from "./Attribute.global.vue?vue&type=script&lang=ts&"
export * from "./Attribute.global.vue?vue&type=script&lang=ts&"
import style0 from "./Attribute.global.vue?vue&type=style&index=0&id=af619e0c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af619e0c",
  null
  
)

export default component.exports